import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

// Flag global para suprimir erros durante restart do backend
let isBackendRestarting = false;

export const setBackendRestarting = (value) => {
	isBackendRestarting = value;
};

const toastError = err => {
	// Não mostra erros durante restart do backend
	if (isBackendRestarting) {
		console.log("⚠️ Erro suprimido durante restart:", err.message);
		return;
	}

	const errorMsg = err.response?.data?.message || err.response?.data?.error;
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else {
		// Só mostra "An error occurred!" para erros que não são de auth
		if (err.response?.status !== 401 && err.response?.status !== 403) {
			// Usa um toastId único para evitar duplicatas
			toast.error("An error occurred!", {
				toastId: "generic-error"
			});
		}
	}
};

export default toastError;
